import _slicedToArray from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.sort.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param object {THREE.Object3D}
 * @return {boolean}
 */
var compatibleObject = function compatibleObject(object) {
  // @TODO: Need properer variantMaterials format validation?
  return object.material !== undefined &&
  // easier than (!object.isMesh && !object.isLine &&
  // !object.isPoints)
  object.userData &&
  // just in case
  object.userData.variantMaterials &&
  // Is this line costly?
  !!Array.from(object.userData.variantMaterials.values()).filter(function (m) {
    return compatibleMaterial(m.material);
  });
};
/**
 * @param material {THREE.Material}
 * @return {boolean}
 */
var compatibleMaterial = function compatibleMaterial(material) {
  // @TODO: support multi materials?
  return material && material.isMaterial && !Array.isArray(material);
};
var GLTFExporterMaterialsVariantsExtension = /*#__PURE__*/function () {
  function GLTFExporterMaterialsVariantsExtension(writer) {
    _classCallCheck(this, GLTFExporterMaterialsVariantsExtension);
    this.writer = writer;
    this.name = 'KHR_materials_variants';
    this.variantNames = [];
  }
  _createClass(GLTFExporterMaterialsVariantsExtension, [{
    key: "beforeParse",
    value: function beforeParse(objects) {
      var _this = this;
      // Find all variant names and store them to the table
      var variantNameSet = new Set();
      var _iterator = _createForOfIteratorHelper(objects),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var object = _step.value;
          object.traverse(function (o) {
            if (!compatibleObject(o)) {
              return;
            }
            var variantMaterials = o.userData.variantMaterials;
            var variantDataMap = o.userData.variantData;
            var _iterator2 = _createForOfIteratorHelper(variantDataMap),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _step2$value = _slicedToArray(_step2.value, 2),
                  variantName = _step2$value[0],
                  variantData = _step2$value[1];
                var variantMaterial = variantMaterials.get(variantData.index);
                // Ignore unloaded variant materials
                if (variantMaterial && compatibleMaterial(variantMaterial.material)) {
                  variantNameSet.add(variantName);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          });
        }
        // We may want to sort?
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      variantNameSet.forEach(function (name) {
        return _this.variantNames.push(name);
      });
    }
  }, {
    key: "writeMesh",
    value: function writeMesh(mesh, meshDef) {
      if (!compatibleObject(mesh)) {
        return;
      }
      var userData = mesh.userData;
      var variantMaterials = userData.variantMaterials;
      var variantDataMap = userData.variantData;
      var mappingTable = new Map();
      // Removes gaps in the variant indices list (caused by deleting variants).
      var reIndexedVariants = new Map();
      var variants = Array.from(variantDataMap.values()).sort(function (a, b) {
        return a.index - b.index;
      });
      var _iterator3 = _createForOfIteratorHelper(variants.entries()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            i = _step3$value[0],
            variantData = _step3$value[1];
          reIndexedVariants.set(variantData.index, i);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var _iterator4 = _createForOfIteratorHelper(variantDataMap.values()),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _variantData = _step4.value;
          var variantInstance = variantMaterials.get(_variantData.index);
          if (!variantInstance || !compatibleMaterial(variantInstance.material)) {
            continue;
          }
          var materialIndex = this.writer.processMaterial(variantInstance.material);
          if (!mappingTable.has(materialIndex)) {
            mappingTable.set(materialIndex, {
              material: materialIndex,
              variants: []
            });
          }
          mappingTable.get(materialIndex).variants.push(reIndexedVariants.get(_variantData.index));
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var mappingsDef = Array.from(mappingTable.values()).map(function (m) {
        return m.variants.sort(function (a, b) {
          return a - b;
        }) && m;
      }).sort(function (a, b) {
        return a.material - b.material;
      });
      if (mappingsDef.length === 0) {
        return;
      }
      var originalMaterialIndex = compatibleMaterial(userData.originalMaterial) ? this.writer.processMaterial(userData.originalMaterial) : -1;
      var _iterator5 = _createForOfIteratorHelper(meshDef.primitives),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var primitiveDef = _step5.value;
          // Override primitiveDef.material with original material.
          if (originalMaterialIndex >= 0) {
            primitiveDef.material = originalMaterialIndex;
          }
          primitiveDef.extensions = primitiveDef.extensions || {};
          primitiveDef.extensions[this.name] = {
            mappings: mappingsDef
          };
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "afterParse",
    value: function afterParse() {
      if (this.variantNames.length === 0) {
        return;
      }
      var root = this.writer.json;
      root.extensions = root.extensions || {};
      var variantsDef = this.variantNames.map(function (n) {
        return {
          name: n
        };
      });
      root.extensions[this.name] = {
        variants: variantsDef
      };
      this.writer.extensionsUsed[this.name] = true;
    }
  }]);
  return GLTFExporterMaterialsVariantsExtension;
}();
export { GLTFExporterMaterialsVariantsExtension as default };